import {
	constantRoutes
} from '@/router'
// import asyncRoutes from '@/router/routerJson.js'
import {
	getPermissionRouterList
} from '@/common/api/public.js'
/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
	return true
}

// 查找父级数据
function findAllParents(tree, childId, parents = []) {
	for (let node of tree) {
		if (node.id === childId) {
			parents.push(node.path)
			return parents;
		}
		if (node.children && node.children.length > 0) {
			const parentCopy = [...parents];
			parentCopy.push(node.path);
			const result = findAllParents(node.children, childId, parentCopy);
			if (result) return result;
		}
	}
	return null;
}
// 设置url
function setPath(id, tree) {
	parent = findAllParents(tree, id)
	if (parent && parent.length) {
		return '/arsme/' + parent.join("/")
	} else {
		return '/arsme/'
	}
}
/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
	const res = []

	routes.forEach(route => {
		const tmp = {
			...route
		}
		if (tmp.children && tmp.children.length) {
			tmp.children = filterAsyncRoutes(tmp.children, roles)
		}
		res.push(tmp)
	})

	return res
}

const state = {
	routes: [],
	addRoutes: []
}

const mutations = {
	SET_ROUTES: (state, routes) => {
		state.addRoutes = routes
		state.routes = constantRoutes.concat(routes)
	}
}

const actions = {
	generateRoutes({
		commit
	}, role) {
		return new Promise(async (resolve, reject) => {
			try {
				const {
					data
				} = await getPermissionRouterList({app_id:1})

				let fun = (arr) => {
					arr.forEach((item, index) => {

						if (item.children && item.children.length) {
							item.component = {
								render: h => h('router-view')
							};
							fun(item.children)
						} else {
							if (item.component) {
								item.copyComponent = item.component.replace('@/views/', '')
								item.component = (() => import(
									`@/views/${item.copyComponent}`))
							}
							item.meta.url = setPath(item.id, data)
						}
					})
				}
				let asyncRoutes = []
				if (data && data.length) {
					fun(data)
					asyncRoutes = [{
						path: "/arsme",
						name: "Home",
						meta: {
							title: "首页",
							permission: [1, 2, 3, 4, 5],
						},
						component: () => import("@/views/home/home"),
						children: data
					}]
				} else {
					asyncRoutes = [{
						path: '/empty',
						name:'NotRouterEmpty',
						component: () => import('@/views/error-page/empty'),
					}]
				}
				let accessedRoutes = filterAsyncRoutes(asyncRoutes, role)
				commit('SET_ROUTES', accessedRoutes)
				resolve(accessedRoutes)
			} catch (error) {
				console.log(error)
				reject(error)
			}

		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}